import BaseModel from 'src/model/base.model';

class EcheckPermissionModel extends BaseModel {
  public clientEmail: string = '';
  public realName: string = '';
  public clientIdentity: number = 0;
  public id: number = 0;
}

export default EcheckPermissionModel;
